// Chakra imports
import {
  Flex,
  Spacer,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
// Custom components
import Card from "../../../../components/Card/Card";
import CardBody from "../../../../components/Card/CardBody";
import React, { ReactNode } from "react";

interface BuiltByDevelopersProps {
  image: ReactNode;
}

const BuiltByDevelopers: React.FC<BuiltByDevelopersProps> = ({ image }) => {
  const title = "Profit In The Markets. Presence In Your Life";
  const name = "Welcome to the Tessera Community";
  const description = "Access ready to execute trades, hands-on educational materials, and expert guidance tailored to help you make an income through trading.";
  const textColor = useColorModeValue("gray.700", "white");

  return (
    <Card maxHeight={{ lg: "240px" }} p={{ sm: "1rem", lg: "1.2rem" }} w="100%">
      <CardBody w='100%' h={{ sm: "auto", lg: "100%" }}>
        <Flex 
          flexDirection={{ sm: "column", lg: "row" }} 
          w='100%' 
          h={{ sm: "auto", lg: "100%" }}>
          <Flex
            flexDirection='column'
            h={{ sm: "auto", lg: "100%" }}
            lineHeight='1.6'
            w={{ sm: "100%", lg: "50%" }}
            minW="0"
            pr={{ lg: "1rem" }}>
            <Text 
              fontSize='sm' 
              color='gray.400' 
              fontWeight='medium' 
              fontFamily="'IBM Plex Sans', sans-serif" 
              textTransform="uppercase" 
              mb="0.5rem">
              {title}
            </Text>
            <Text 
              fontSize={{ sm: "lg", md: "xl" }} 
              color="#38BBD1" 
              fontWeight='medium' 
              pb='.5rem' 
              mb="0.5rem">
              {name}
            </Text>
            <Text 
              fontSize='sm' 
              color='gray.400' 
              fontWeight='normal'
              mb={{ sm: "0.5rem", lg: "0" }}>
              {description}
            </Text>
            <Spacer display={{ sm: "none", lg: "block" }} />
          </Flex>
          {image && (
            <>
              <Spacer display={{ base: "none", lg: "block" }} />
              <Flex
                bg='linear-gradient(135deg, #38BBD1, #3EEAEC)'
                align='center'
                justify='center'
                borderRadius='15px'
                w={{ lg: "40%" }}
                h={{ lg: "100%" }}
                display={{ base: "none", md: "none", lg: "flex" }}
                flexShrink={0}>
                {image}
              </Flex>
            </>
          )}
        </Flex>
      </CardBody>
    </Card>
  );
};

export default BuiltByDevelopers;

